import { Box, createTheme, Typography } from "@mui/material";
import { makeStyles, styled } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  body: {
    display: "flex",
    flexDirection:"column",
    // paddingBottom: "30px",
    // paddingRight:"40px",
    // paddingLeft:"40px",
    padding: "1rem",
  },
  controlSection: {
    display:"flex",
    gap:"13px",
    marginBottom:"42px",
  },
  inboxSection: {
    gap:"40px",
    display:"flex",
    flexDirection:"column",
    justifyContent:"center",
  }
}));


export const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#36899f',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

export const ParaText = styled(Typography)(()=>({
  fontSize: '1rem',
  color: '#fff',
  margin: '0px'
})) 

export const TabsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(255,255,255,0.1)',
  padding: '5px',
  borderRadius: '15px',
  width: '100%',
  boxSizing: 'border-box',
}));


